import { useQuery } from 'react-query';

import { getV2ApiCompanyIdInternationalTransfersRecipientRequirements } from 'src/client/spendesk-api';

export const useInternationalRecipientRequirementsQuery = (
  quoteId: string,
  companyId: string,
  acceptLanguage?: string,
) => {
  return useQuery(
    [
      'internationalTransfers',
      'recipientRequirements',
      quoteId,
      acceptLanguage,
    ],
    async () => {
      const response =
        await getV2ApiCompanyIdInternationalTransfersRecipientRequirements({
          path: { companyId },
          query: { quoteId, acceptLanguage },
        });

      if (response.statusCode !== 200) {
        throw new Error('Failed to fetch recipient requirements');
      }

      return response.body.data.requirements;
    },
    {
      retry: 5,
      refetchOnWindowFocus: false,
    },
  );
};
